// extracted by mini-css-extract-plugin
export default {"formWrapper":"UserManagementUsersEditDetailsTemplate_formWrapper__RtWTc"};